import { default as LinkifyIt } from "linkify-it";
import * as React from "react";
import { replaceNewlinesWithBr } from "@ms/uno-utilities/lib/local/ReactUtilities";
export const linkify = new LinkifyIt();
/**
 * Convert urls in a string into renderable links
 * @param description Input string
 * @returns React.Fragment of string with links replaced with <a> and newlines with <br/>
 */ export function convertUrlsToRenderableLinks(description) {
    if (!description) {
        return null;
    }
    const text = description;
    const urlMatches = linkify.match(description);
    if (!urlMatches) {
        const stringElements = replaceNewlinesWithBr(description);
        return /*#__PURE__*/ React.createElement(React.Fragment, null, ...stringElements);
    }
    const descriptionElements = [];
    let startPos = 0;
    for(let i = 0; i < urlMatches.length; i++){
        const urlMatch = urlMatches[i];
        if (startPos < urlMatch.index) {
            const stringthing = text.substring(startPos, urlMatch.index);
            const stringElements = replaceNewlinesWithBr(stringthing);
            descriptionElements.push(...stringElements);
        }
        descriptionElements.push(/*#__PURE__*/ React.createElement("a", {
            tabIndex: 0,
            href: urlMatch.url,
            target: "_blank",
            rel: "noopener noreferrer",
            onFocus: (e)=>e.stopPropagation()
        }, urlMatch.text));
        startPos = urlMatch.lastIndex;
    }
    if (startPos < text.length) {
        // rest of string
        const stringElements = replaceNewlinesWithBr(text.substring(startPos));
        descriptionElements.push(...stringElements);
    }
    // Create fragment directly with spread op to fix React missing key error
    return /*#__PURE__*/ React.createElement(React.Fragment, null, ...descriptionElements);
}
